<template>
    <div>
        <span :class="chipClass" class="chip"></span> {{ label }}
    </div>
</template>

<script>

export default {
    props: {
        state: {
            type: String,
            required: true
        },
        id: {
            type: Number,
            required: true
        },
        errorCode: {
            type: Number,
            required: false
        }
    },
    computed: {
        label() {
            switch(this.state) {
                case 'completed':
                    return this.$l10n.__('Traité');
                case 'error':
                    if(this.errorCode === 1) {
                        return this.$l10n.__('Erreur nombre de pages');
                    } else {
                        return this.$l10n.__('Erreur technique');
                    }
                case 'pending':
                case 'processing':
                    return this.$l10n.__('En cours de traitement');
            }
        },
        chipClass() {
            switch(this.state) {
                case 'completed':
                    return 'chip-success';
                case 'error':
                    return 'chip-error';
                case 'pending':
                case 'processing':
                    return 'chip-default';
            }
        }
    }
}
</script>